import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchRouteManagementCreate = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'createRoute',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });

  const palletBoxParams = payload.appContext.appContext === 'pallet' ? {
    transferLocations: payload.params.transferLocations,
  } : {};

  return axios.post(serviceUrl, {
    assetType: payload.params.assetType,
    comments: payload.params.comments,
    direction: payload.params.direction,
    endDate: payload.params.endDate !== null ? moment(payload.params.endDate).format('YYYY-MM-DD') : null,
    inboundImpc: payload.params.inboundImpc,
    outboundImpc: payload.params.outboundImpc,
    priority: payload.params.priority,
    startDate: moment(payload.params.startDate).format('YYYY-MM-DD'),
    ...palletBoxParams,
  });
};

export default apiFetchRouteManagementCreate;
